export default ({ request }) => ({
  exportPptGetList(data) {
    return request({
      baseURL: '/api',
      url: '/export/ppt/template/list',
      method: 'post',
      data
    })
  }
})
